/**
 * Kontrola IBAN ešte pred odoslaním - rovnaká ako na serveri
 * (`backend/apps/core/iban.py`): formát a kontrolný súčet mod 97.
 */
export function normalizeIban(value: string) {
  return value.replace(/[^0-9A-Za-z]/g, '').toUpperCase()
}

export function isValidIban(value: string) {
  const iban = normalizeIban(value)
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(iban)) return false
  const rearranged = iban.slice(4) + iban.slice(0, 4)
  let rest = 0
  for (const char of rearranged) {
    const digits = String(parseInt(char, 36))
    for (const digit of digits) rest = (rest * 10 + Number(digit)) % 97
  }
  return rest === 1
}
